import URLS from "./URLS";
import Cookie from "universal-cookie";
import {
    message, Modal
} from "antd";

import logout from "../api/logout";

// Login 
export function login(data) {
    fetch(URLS.LOGIN, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                new Cookie().set("access_token", result.data.accessToken, {
                    path: "/"
                });
                new Cookie().set("email", data.email, {
                    path: "/"
                });
                new Cookie().set("isLoggedIn", true, {
                    path: "/"
                });
                new Cookie().set("user", JSON.stringify(result.data.user), {
                    path: "/"
                });
                message.success({
                    content: "Connexion validée",
                    style: {
                        marginTop: '40vh',
                    }
                });
                location.href = "/"
            } else {
                message.error({
                    content: "Connexion refusée: " + result.errorMessage,
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 10
                });

            }
        })
        .catch(error => {
            message.error({
                content: "Connexion refusée :" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            })

        })
};

// logout
export function logoutUser() {
    logout().then((res) => {
        if (res?.status === 200 || res?.status === 302 || res === "Hello World") { window.location.href = "/login" }
    })

    const c = new Cookie();
    c.remove("access_token", { path: "/" });
    c.remove("email", { path: "/" });
    c.remove("isLoggedIn", { path: "/" });
    c.remove("user", { path: "/" })
    // location.href = "/login"
};


export function createUser(data) {
    fetch(URLS.CREATE_USER, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                Modal.success({
                    title: 'Bienvenue dans la communauté Resilience',
                    closable: true,
                    content: 'Votre compte a été créé, vous allez recevoir un mail de confirmation'
                });
                setTimeout(() => { location.href = "/" }, 3000);
            } else {
                message.error({
                    content: "une erreur s'est produite: " + result.errorMessage,
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 10
                });
            }
        })
        .catch(error => {
            message.error({
                content: "une erreur s'est produite:" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            })

        })
};
export function activateAccount(data) {
    fetch(URLS.VERIF_MAIL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                Modal.success({
                    title: 'Bienvenue',
                    closable: true,
                    content: "Votre compte a vient d'être validé"
                });
                new Cookie().set("access_token", result.data.accessToken, {
                    path: "/"
                });
                new Cookie().set("email", data.email, {
                    path: "/"
                });
                new Cookie().set("isLoggedIn", true, {
                    path: "/"
                });
                new Cookie().set("user", JSON.stringify(result.data.user), {
                    path: "/"
                });
                setTimeout(() => { location.href = "/" }, 3000);
            } else {
                message.error({
                    content: "une erreur s'est produite: " + result.errorMessage,
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 10
                });
            }
        })
        .catch(error => {
            message.error({
                content: "une erreur s'est produite:" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            })

        })
};

export function forgotPassword(data) {
    // Transform email to email_adress for the API
    const apiData = {
        email_adress: data.email
    };
    
    fetch(URLS.RESET_PASSWORD, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(apiData)
    }).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                message.success({
                    content: "Votre demande a été prise en compte. Un mail vient de vous être envoyé",
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 5
                });
                setTimeout(() => { location.href = "/" }, 3000);
            } else {
                message.error({
                    content: "une erreur s'est produite: " + result.errorMessage,
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 10
                });
            }
        })
        .catch(error => {
            message.error({
                content: "une erreur s'est produite:" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            })

        })
};


export function subscribeToNewsletter(data) {
    fetch(URLS.SUBSCRIBE_NEWSLETTER, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                message.success({
                    content: "Votre inscription à notre newsletter est prise en compte",
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 5
                });

            } else {
                message.error({
                    content: "une erreur s'est produite: " + result.errorMessage,
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 10
                });
            }
        })
        .catch(error => {
            message.error({
                content: "une erreur s'est produite:" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            })

        })
};


export function getAllNews() {
    return fetch(URLS.FETCH_NEWS).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                return result.data;
            }
        })
        .catch(error => {
            message.error({
                content: "une erreur s'est produite:" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            })

        })
};

export function getUserDetails() {
    fetch(URLS.GET_USER_DETAILS, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "token": new Cookie().get("access_token")
        }
    }).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                new Cookie().set("user", JSON.stringify(result.data), {
                    path: "/"
                });
                new Cookie().set("email", result.data.email, {
                    path: "/"
                });
                new Cookie().set("isLoggedIn", true, {
                    path: "/"
                });

            } else {
                message.error({
                    content: "une erreur s'est produite: " + result.errorMessage,
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 10
                });
                setTimeout(() => { logoutUser() }, 3000);
            }


        })
        .catch(error => {
            message.error({
                content: "une erreur s'est produite:" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            });
            setTimeout(() => { logoutUser() }, 3000);

        })
};


export function modifyPassword(data) {
    fetch(URLS.UPDATE_PASSWORD + new Cookie().get("user").userId, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            "token": new Cookie().get("access_token")
        },
        body: JSON.stringify(data)
    }).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                message.success({
                    content: "Votre mot de passe a bien été modifié",
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 5
                });
                setTimeout(() => { logoutUser() }, 3000);
            } else {
                message.error({
                    content: "une erreur s'est produite: " + result.errorMessage,
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 10
                });
            }
        })
        .catch(error => {
            message.error({
                content: "une erreur s'est produite:" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            })
            //setTimeout(() => {logoutUser()}, 3000);
        })
};

export function getAllResilienceProject() {
    return fetch(URLS.FETCH_RESILIENCE_PROJECT).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                return result.data;
            }
        })
        .catch(error => {
            message.error({
                content: "une erreur s'est produite:" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            })

        })
};

export function getResilienceProjectById(projectId) {
    return fetch(URLS.FETCH_RESILIENCE_PROJECT + "/" + projectId).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                return result.data;
            }
        })
        .catch(error => {
            message.error({
                content: "une erreur s'est produite:" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            })

        })
};

export function getAllProjectSubmission() {
    return fetch(URLS.FETCH_PROJECT_SUBMISSION).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                return result.data;
            }
        })
        .catch(error => {
            message.error({
                content: "une erreur s'est produite:" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            })

        })
};

export function voteForProject(data) {
    fetch(URLS.VOTE_PROJECT_SUBMISSION, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                message.success({
                    content: "Merci : votre vote a bien été pris en compte",
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 5
                });
                setTimeout(() => { location.href = "/projects-submission" }, 3000);
            } else {
                message.error({
                    content: "une erreur s'est produite: " + result.errorMessage,
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 10
                });
            }
        })
        .catch(error => {
            message.error({
                content: "une erreur s'est produite:" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            })
            //setTimeout(() => {logoutUser()}, 3000);
        })
};

export function submitProjectIdea(data) {
    fetch(URLS.PUSH_PROJECT_SUBMISSION, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then(r => r.json())
        .then(result => {
            if (result.success === true) {
                message.success({
                    content: "Merci : votre vote a bien été pris en compte",
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 5
                });

            } else {
                message.error({
                    content: "une erreur s'est produite: " + result.errorMessage,
                    style: {
                        marginTop: '40vh',
                    },
                    duration: 10
                });
            }
        })
        .catch(error => {
            message.error({
                content: "une erreur s'est produite:" + error,
                style: {
                    marginTop: '40vh',
                },
                duration: 10
            })
            //setTimeout(() => {logoutUser()}, 3000);
        })
};

export default {
    logoutUser, login, createUser, activateAccount, forgotPassword, getAllNews, subscribeToNewsletter, getUserDetails, modifyPassword,
    getAllResilienceProject, getResilienceProjectById, getAllProjectSubmission, voteForProject, submitProjectIdea
};
/*
module.exports = {
 
  
  resendMailActivation: data =>
    fetch(URLS.RESEND_MAIL_ACTIVATION, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    }).then(r => r.json()),

  getUserDetails: data =>
    fetch(URLS.GET_USER_DETAILS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    }).then(r => r.json()),
  fetchNews: () => fetch(URLS.FETCH_NEWS).then(r => r.json())
};
*/